// 고객 상태
export const CUSTOMER_STATUSES = [
  '상담접수', '방문예약', '상담완료', '견적전달', '계약완료', '진행중', '종료', '보류', '취소'
] as const;

export const CUSTOMER_STATUS_COLORS: Record<string, string> = {
  '상담접수': 'bg-gray-100 text-gray-700',
  '방문예약': 'bg-blue-100 text-blue-700',
  '상담완료': 'bg-green-100 text-green-700',
  '견적전달': 'bg-orange-100 text-orange-700',
  '계약완료': 'bg-purple-100 text-purple-700',
  '진행중': 'bg-indigo-100 text-indigo-700',
  '종료': 'bg-gray-800 text-white',
  '보류': 'bg-yellow-100 text-yellow-700',
  '취소': 'bg-red-100 text-red-700',
};

// 성별
export const GENDERS = [
  { value: 'MALE', label: '남성' },
  { value: 'FEMALE', label: '여성' },
];

// 상품 유형
export const PRODUCT_TYPES = [
  { value: 'SALE', label: '판매용' },
  { value: 'RENTAL', label: '대여용' },
  { value: 'PACKAGE', label: '패키지' },
];

export const PRODUCT_TYPE_COLORS: Record<string, string> = {
  SALE: 'bg-green-100 text-green-700',
  RENTAL: 'bg-orange-100 text-orange-700',
  PACKAGE: 'bg-purple-100 text-purple-700',
};

// 계약 유형
export const CONTRACT_TYPES = [
  { value: 'RENTAL', label: '대여' },
  { value: 'CUSTOM', label: '맞춤' },
  { value: 'PURCHASE', label: '구매' },
];

export const CONTRACT_TYPE_COLORS: Record<string, string> = {
  RENTAL: 'bg-orange-100 text-orange-700',
  CUSTOM: 'bg-blue-100 text-blue-700',
  PURCHASE: 'bg-teal-100 text-teal-700',
};

// 계약 상태
export const CONTRACT_STATUSES = [
  { value: 'ACTIVE', label: '진행중' },
  { value: 'COMPLETED', label: '완료' },
  { value: 'CANCELLED', label: '취소' },
];

export const CONTRACT_STATUS_COLORS: Record<string, string> = {
  ACTIVE: 'bg-green-100 text-green-700',
  COMPLETED: 'bg-blue-100 text-blue-700',
  CANCELLED: 'bg-red-100 text-red-700',
};

// 드레스 타입 (품목 카테고리)
export const ITEM_CATEGORIES = [
  { value: 'BALL_GOWN', label: '볼가운(벨라인)' },
  { value: 'MERMAID', label: '머메이드' },
  { value: 'A_LINE', label: 'A라인' },
  { value: 'EMPIRE', label: '엠파이어' },
  { value: 'SHEATH', label: '시스' },
  { value: 'PRINCESS', label: '프린세스' },
  { value: 'MINI', label: '미니' },
  { value: 'TRUMPET', label: '트럼펫' },
  { value: 'VEIL', label: '베일' },
  { value: 'ACCESSORIES', label: '악세서리' },
  { value: 'PARENT_DRESS', label: '혼주 드레스' },
  { value: 'ETC', label: '기타' },
];

// 일정 카테고리
export const SCHEDULE_CATEGORIES = [
  { value: 'TASK', label: '업무일정', color: 'bg-cyan-500' },
  { value: 'RENTAL', label: '대여일정', color: 'bg-teal-500' },
  { value: 'CONSULTATION', label: '상담', color: 'bg-blue-500' },
  { value: 'FITTING', label: '피팅', color: 'bg-green-500' },
  { value: 'FIRST_FITTING', label: '1차 피팅', color: 'bg-orange-500' },
  { value: 'SECOND_FITTING', label: '2차 피팅', color: 'bg-yellow-500' },
  { value: 'ALTERATION', label: '수선', color: 'bg-purple-500' },
  { value: 'SELECT', label: '셀렉', color: 'bg-pink-500' },
  { value: 'PICKUP', label: '출고', color: 'bg-red-500' },
  { value: 'RETURN', label: '반납', color: 'bg-gray-500' },
  { value: 'WEDDING', label: '본식일', color: 'bg-amber-500' },
  { value: 'PAYMENT', label: '결제', color: 'bg-lime-500' },
  { value: 'REHEARSAL', label: '리허설', color: 'bg-violet-500' },
];

export const SCHEDULE_CATEGORY_COLORS: Record<string, string> = {
  TASK: 'bg-cyan-100 text-cyan-700 border-cyan-300',
  RENTAL: 'bg-teal-100 text-teal-700 border-teal-300',
  CONSULTATION: 'bg-blue-100 text-blue-700 border-blue-300',
  FITTING: 'bg-green-100 text-green-700 border-green-300',
  FIRST_FITTING: 'bg-orange-100 text-orange-700 border-orange-300',
  SECOND_FITTING: 'bg-yellow-100 text-yellow-700 border-yellow-300',
  ALTERATION: 'bg-purple-100 text-purple-700 border-purple-300',
  SELECT: 'bg-pink-100 text-pink-700 border-pink-300',
  PICKUP: 'bg-red-100 text-red-700 border-red-300',
  RETURN: 'bg-gray-100 text-gray-700 border-gray-300',
  WEDDING: 'bg-amber-100 text-amber-700 border-amber-300',
  PAYMENT: 'bg-lime-100 text-lime-700 border-lime-300',
  REHEARSAL: 'bg-violet-100 text-violet-700 border-violet-300',
};

// 일정 상태
export const SCHEDULE_STATUSES = ['예정', '도착', '진행중', '완료', '지연', '노쇼', '취소'] as const;

export const SCHEDULE_STATUS_COLORS: Record<string, string> = {
  '예정': 'bg-blue-100 text-blue-700',
  '도착': 'bg-teal-100 text-teal-700',
  '진행중': 'bg-indigo-100 text-indigo-700',
  '완료': 'bg-green-100 text-green-700',
  '지연': 'bg-red-100 text-red-700',
  '노쇼': 'bg-gray-800 text-white',
  '취소': 'bg-red-100 text-red-700',
};

// 작업 유형
export const WORK_TYPES = [
  { value: 'RENTAL', label: '대여' },
  { value: 'CUSTOM', label: '맞춤' },
];

// 작업 파이프라인
export const RENTAL_PIPELINE = [
  '셀렉', '피팅', '수선', '출고', '반납', '클리닝', '보관'
];

export const CUSTOM_PIPELINE = [
  '발주', '입고', '피팅', '수선', '출고', '보관'
];

// 결제 유형
export const PAYMENT_TYPES = [
  { value: 'FULL', label: '일시납부' },
  { value: 'CONTRACT', label: '계약금' },
  { value: 'INTERMEDIATE', label: '중도금' },
  { value: 'BALANCE', label: '잔금' },
  { value: 'ETC', label: '기타' },
];

export const PAYMENT_TYPE_COLORS: Record<string, string> = {
  FULL: 'bg-purple-100 text-purple-700',
  CONTRACT: 'bg-blue-100 text-blue-700',
  INTERMEDIATE: 'bg-orange-100 text-orange-700',
  BALANCE: 'bg-green-100 text-green-700',
  ETC: 'bg-gray-100 text-gray-700',
};

// 결제 상태
export const PAYMENT_STATUSES = [
  { value: 'COMPLETED', label: '결제완료' },
  { value: 'SCHEDULED', label: '결제예정' },
  { value: 'REFUNDED', label: '환불됨' },
  { value: 'CANCELLED', label: '취소됨' },
];

export const PAYMENT_STATUS_COLORS: Record<string, string> = {
  COMPLETED: 'bg-green-100 text-green-700',
  SCHEDULED: 'bg-blue-100 text-blue-700',
  REFUNDED: 'bg-orange-100 text-orange-700',
  CANCELLED: 'bg-red-100 text-red-700',
};

// 결제 수단
export const PAYMENT_METHODS = [
  { value: 'CARD', label: '카드' },
  { value: 'TRANSFER', label: '계좌이체' },
  { value: 'CASH', label: '현금' },
];

// 정산 상태
export const SETTLEMENT_STATUSES = [
  { value: 'PENDING', label: '대기' },
  { value: 'SENT', label: '발송' },
  { value: 'COMPLETED', label: '완료' },
];

export const SETTLEMENT_STATUS_COLORS: Record<string, string> = {
  PENDING: 'bg-yellow-100 text-yellow-700',
  SENT: 'bg-blue-100 text-blue-700',
  COMPLETED: 'bg-green-100 text-green-700',
};

// 고객 구분
export const CUSTOMER_TYPES = [
  { value: 'BRIDE', label: '신부' },
  { value: 'GROOM', label: '신랑' },
  { value: 'PARENT', label: '혼주' },
  { value: 'ETC', label: '기타' },
];

// 유입경로
export const REFERRAL_SOURCES = [
  { value: '웨딩플래너', label: '웨딩플래너' },
  { value: '인스타그램', label: '인스타그램' },
  { value: '블로그/카페', label: '블로그/카페' },
  { value: '지인소개', label: '지인소개' },
  { value: '네이버검색', label: '네이버검색' },
  { value: '유튜브', label: '유튜브' },
  { value: '방문(워크인)', label: '방문(워크인)' },
  { value: '기타', label: '기타' },
];

export const REFERRAL_SOURCE_DETAILS: Record<string, { value: string; label: string }[]> = {
  '웨딩플래너': [
    { value: '더채플', label: '더채플' },
    { value: '루나웨딩', label: '루나웨딩' },
    { value: '아이웨딩', label: '아이웨딩' },
    { value: '듀오웨드', label: '듀오웨드' },
    { value: '기타플래너', label: '기타 플래너' },
  ],
  '인스타그램': [
    { value: '피드광고', label: '피드 광고' },
    { value: '릴스', label: '릴스' },
    { value: '해시태그검색', label: '해시태그 검색' },
    { value: 'DM문의', label: 'DM 문의' },
  ],
  '블로그/카페': [
    { value: '네이버블로그', label: '네이버 블로그' },
    { value: '웨딩카페', label: '웨딩 카페' },
    { value: '후기게시판', label: '후기 게시판' },
  ],
  '지인소개': [
    { value: '기존고객', label: '기존 고객 소개' },
    { value: '지인', label: '지인 소개' },
  ],
};

// 섹션별 카테고리 매핑
export const SECTION_CATEGORY_MAP: Record<string, string[]> = {
  TASK: ['TASK'],
  RENTAL: ['RENTAL'],
  STORE: ['CONSULTATION', 'FITTING', 'FIRST_FITTING', 'SECOND_FITTING', 'ALTERATION', 'SELECT', 'PICKUP', 'RETURN', 'WEDDING', 'PAYMENT', 'REHEARSAL'],
  CONSULTATION: ['CONSULTATION'],
};

// 일정 섹션
export const SCHEDULE_SECTIONS = [
  { value: 'TASK', label: '업무일정' },
  { value: 'RENTAL', label: '대여일정' },
  { value: 'STORE', label: '매장일정' },
  { value: 'CONSULTATION', label: '상담일정' },
];

// 입출고 구분
export const WORK_ORDER_CATEGORIES = [
  { value: 'ORDER', label: '발주' },
  { value: 'RELEASE', label: '출고' },
  { value: 'RETURN', label: '반납' },
  { value: 'ALTERATION', label: '수선' },
  { value: 'CLEANING', label: '클리닝' },
];

export const WORK_ORDER_CATEGORY_COLORS: Record<string, string> = {
  ORDER: 'bg-blue-100 text-blue-700',
  RELEASE: 'bg-green-100 text-green-700',
  RETURN: 'bg-orange-100 text-orange-700',
  ALTERATION: 'bg-purple-100 text-purple-700',
  CLEANING: 'bg-cyan-100 text-cyan-700',
};

// 입출고 상태
export const INVENTORY_STATUSES = [
  { value: '', label: '전체' },
  { value: '셀렉', label: '셀렉' },
  { value: '피팅', label: '피팅' },
  { value: '수선', label: '수선' },
  { value: '출고', label: '출고' },
  { value: '반납', label: '반납' },
  { value: '클리닝', label: '클리닝' },
  { value: '보관', label: '보관' },
];

export const INVENTORY_STATUS_COLORS: Record<string, string> = {
  '셀렉': 'bg-pink-100 text-pink-700',
  '피팅': 'bg-green-100 text-green-700',
  '수선': 'bg-purple-100 text-purple-700',
  '출고': 'bg-blue-100 text-blue-700',
  '반납': 'bg-orange-100 text-orange-700',
  '클리닝': 'bg-cyan-100 text-cyan-700',
  '보관': 'bg-yellow-100 text-yellow-700',
};

// 입출고 구분 (품목별)
export const INVENTORY_CATEGORIES = [
  { value: 'DRESS', label: '드레스' },
  { value: 'VEIL', label: '베일' },
  { value: 'ACCESSORIES', label: '악세서리' },
  { value: 'ALTERATION', label: '수선' },
];

// 입금 유형
export const DEPOSIT_TYPES = [
  { value: 'CASH', label: '현금' },
  { value: 'TRANSFER', label: '계좌이체' },
  { value: 'CARD', label: '카드' },
  { value: 'ETC', label: '기타' },
];

// 구매 품목 카테고리
export const PURCHASE_CATEGORIES = [
  { value: 'DRESS', label: '드레스' },
  { value: 'VEIL', label: '베일' },
  { value: 'ACCESSORIES', label: '악세서리' },
  { value: 'FABRIC', label: '원단' },
  { value: 'CLEANING', label: '클리닝용품' },
  { value: 'ETC', label: '기타' },
];

// 구매 결제 상태
export const PURCHASE_PAYMENT_STATUSES = [
  { value: 'UNPAID', label: '미결제' },
  { value: 'PARTIAL', label: '부분결제' },
  { value: 'PAID', label: '결제완료' },
];

export const PURCHASE_PAYMENT_STATUS_COLORS: Record<string, string> = {
  UNPAID: 'bg-red-100 text-red-700',
  PARTIAL: 'bg-yellow-100 text-yellow-700',
  PAID: 'bg-green-100 text-green-700',
};

// 거래 유형
export const TRANSACTION_TYPES = [
  { value: 'INCOME', label: '수입' },
  { value: 'EXPENSE', label: '지출' },
];

// 전송 상태
export const INVOICE_SEND_STATUSES = [
  { value: 'PENDING', label: '대기' },
  { value: 'SENT', label: '발송완료' },
  { value: 'FAILED', label: '실패' },
];

export const INVOICE_SEND_STATUS_COLORS: Record<string, string> = {
  PENDING: 'bg-yellow-100 text-yellow-700',
  SENT: 'bg-green-100 text-green-700',
  FAILED: 'bg-red-100 text-red-700',
};
